import { Header1, Paragraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { trackClickOnBanner } from './tracking';

export function CountrysideBuildersBanner() {
  return (
    <a
      className={styles['container']}
      onClick={trackClickOnBanner}
      href={
        'https://www.cian.ru/country-builders/?utm_source=banner_country-builders&utm_medium=cpm&utm_campaign=listing_desktop'
      }
      target="_blank"
      rel="noreferrer"
    >
      <span className={styles['title']}>
        <Header1 as={'span'}>Каталог строительных компаний</Header1>
      </span>
      <Paragraph1 as={'span'}>Подборка от экспертов Циан: компании с хорошей историей и отзывами</Paragraph1>
      <div className={styles['button-wrapper']}>
        <span className={styles['button']}>Выбрать</span>
      </div>
    </a>
  );
}
